import { lazyPage } from './lazyPage';
import type { AppRoute } from './types';

const ModuleMenu = lazyPage(() => import('@/pages/ModuleMenu'));
const CommunicationDashboard = lazyPage(() => import('@/pages/communication/Dashboard'));
const Announcements = lazyPage(() => import('@/pages/communication/Announcements'));
const Notices = lazyPage(() => import('@/pages/communication/Notices'));
const CommEmail = lazyPage(() => import('@/pages/communication/Email'));
const CommSMS = lazyPage(() => import('@/pages/communication/SMS'));
const CommPush = lazyPage(() => import('@/pages/communication/PushNotifications'));
const ParentCommunication = lazyPage(() => import('@/pages/communication/ParentCommunication'));
const FacultyCommunication = lazyPage(() => import('@/pages/communication/FacultyCommunication'));
const StudentCommunication = lazyPage(() => import('@/pages/communication/StudentCommunication'));
const EventCalendar = lazyPage(() => import('@/pages/communication/EventCalendar'));
const CommFeedback = lazyPage(() => import('@/pages/communication/Feedback'));
const EmergencyAlerts = lazyPage(() => import('@/pages/communication/EmergencyAlerts'));
const MessageTemplates = lazyPage(() => import('@/pages/communication/MessageTemplates'));
const CommunicationReports = lazyPage(() => import('@/pages/communication/Reports'));

export const communicationRoutes: AppRoute[] = [
  {
    path: 'communication',
    title: 'Communication',
    children: [
      { path: '', title: 'Communication', component: ModuleMenu },
      { path: 'dashboard', title: 'Dashboard', component: CommunicationDashboard },
      { path: 'announcements', title: 'Announcements', component: Announcements },
      { path: 'notices', title: 'Notices / Circulars', component: Notices },
      { path: 'email', title: 'Email', component: CommEmail },
      { path: 'sms', title: 'SMS', component: CommSMS },
      { path: 'push', title: 'Push Notifications', component: CommPush },
      { path: 'parent', title: 'Parent Communication', component: ParentCommunication },
      { path: 'faculty', title: 'Faculty Communication', component: FacultyCommunication },
      { path: 'student', title: 'Student Communication', component: StudentCommunication },
      { path: 'events', title: 'Event Calendar', component: EventCalendar },
      { path: 'feedback', title: 'Feedback', component: CommFeedback },
      { path: 'alerts', title: 'Emergency Alerts', component: EmergencyAlerts },
      { path: 'templates', title: 'Message Templates', component: MessageTemplates },
      { path: 'reports', title: 'Communication Reports', component: CommunicationReports },
    ],
  },
];
